import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/home/users')({
	beforeLoad: () => {
		return {
			getTitle: 'Users'
		};
	}
});
